export default __webpack_public_path__ + "static/media/ic_PurchasesRipleyCom.7934ded7.svg";